export const programDetailsEn = {};

export const programDetailsFr = {};
